import React, { useEffect, useState } from "react";
import {
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    useInput,
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import CreateToolbar from "../../Custom/create-save-button";
import { makeStyles } from "@material-ui/core/styles";
import { CustomBooleanInput } from "../../Signet/util";
import { apiUrl } from "../../../dataProvider";
import axios from "axios";
import { validateRequired } from "../../../utils/Validations";

const useStyles = makeStyles({
    container: {
        width: '100%',
    },
});

const DesignPatternNameSelect = (props) => {
    const [options, setOptions] = useState([]);
    const { input: nameInput } = useInput({ source: "name", validate: [validateRequired] });
    const { input: skuInput } = useInput({ source: "sku_code" });

    useEffect(() => {
        const fetchDesignPatternTypes = async () => {
            try {
                const response = await axios.get(`${apiUrl}/netsuite/design-pattern-types`);
                if (response.data && response.data.data) {
                    const formattedOptions = response.data.data.map(item => ({
                        id: item.name,
                        name: item.name,
                        sku_code: item.sku_code
                    }));
                    setOptions(formattedOptions);
                }
            } catch (error) {
                console.error("Error fetching design pattern types:", error);
            }
        };
        fetchDesignPatternTypes();
    }, []);

    useEffect(() => {
        if (nameInput.value && options.length > 0) {
            const selectedOption = options.find(opt => opt.name === nameInput.value);
            if (selectedOption) {
                skuInput.onChange(selectedOption.sku_code);
            }
        }
    }, [nameInput.value, options, skuInput]);

    return (
        <SelectInput
            {...props}
            source="name"
            label="Name"
            choices={options}
            validate={[validateRequired]}
            fullWidth
        />
    );
};

const DesignPatternCreate = props => {
    const classes = useStyles();

    return (
        <Create {...props} className="overflow-visible">
            <SimpleForm toolbar={<CreateToolbar />} submitOnEnter={false}>
                <Grid container className={classes.container} justify="space-between">
                    <Grid item xs={5}>
                        <DesignPatternNameSelect />
                    </Grid>
                    <Grid item xs={5}>
                        <TextInput
                            source="sku_code"
                            label="Sku Code"
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={5}>
                        <CustomBooleanInput source="is_inside" label="Is Inside" />
                    </Grid>

                    <Grid item xs={5}>
                        <CustomBooleanInput source="is_reverse" label="Is Reverse" />
                    </Grid>

                    <Grid item xs={5}>
                        <TextInput
                            source="netsuite_id"
                            label="Netsuite ID"
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={5}>
                        <TextInput
                            source="netsuite_value"
                            label="Netsuite Value"
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </SimpleForm>
        </Create>
    );
};

export default DesignPatternCreate;

